import React from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import cs from 'date-fns/locale/cs';
import { useField } from 'formik';
import FormGroup from './FormGroup';

function DatePickerField({ name, label }) {
  registerLocale('cs', cs);

  const [field, , helpers] = useField(name);
  const { value } = field;
  return (
    <FormGroup>
      {label && (
        <label className="input-label" htmlFor={name}>
          {label}
        </label>
      )}
      <ReactDatePicker
        dateFormat="dd.MM.yyyy"
        locale="cs"
        selected={(value && new Date(value)) || null}
        onChange={(val) => {
          helpers.setValue(val);
        }}
      />
    </FormGroup>
  );
}

export default DatePickerField;
